const toCamelCase = (str: string): string =>
  str.includes("_")
    ? str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
    : str;

export const convertObjectToCamelCase = (obj: unknown): unknown => {
  //eslint-disable-line
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(convertObjectToCamelCase);
  }

  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      const camelCaseKey = toCamelCase(key);
      acc[camelCaseKey] = convertObjectToCamelCase(value);
      return acc;
    },
    {} as Record<string, unknown>,
  );
};

export const textToSnakeCase = (str: string): string =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const convertObjectToSnakeCase = (obj: unknown): unknown => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(convertObjectToSnakeCase);
  }

  return Object.entries(obj).reduce(
    (acc: Record<string, unknown>, [key, value]) => {
      const snakeCaseKey = textToSnakeCase(key);
      acc[snakeCaseKey] = convertObjectToSnakeCase(value);
      return acc;
    },
    {} as Record<string, unknown>,
  );
};
